<h2 mat-dialog-title class="create-title" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle><mat-icon>person_add</mat-icon>Create customer</h2>
<div mat-dialog-content class="create-content">
  <p class="create-description">Set up the customer profile and primary contact. Required fields are marked with an asterisk.</p>
  <div class="create-presets"><span>Quick setup</span><button mat-stroked-button type="button" (click)="defaultCustomer()" [disabled]="types.length < 2 || !regions.length">Use defaults</button></div>
  <form class="create-form" id="create-customer-form" #customerForm="ngForm" (ngSubmit)="onSubmit()">
    <!-- <mat-form-field appearance="outline">
    <mat-label>Code</mat-label>
    <input matInput  type="text" required [(ngModel)]="customerPost.code" name="code">
  </mat-form-field> -->
  <mat-form-field appearance="outline">
    <mat-label>Contact Email (Used for default User)</mat-label>
    <input matInput  type="text"
      [(ngModel)]="customerPost.contact_Email" name="contact_Email">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Customer Name</mat-label>
    <input matInput  type="text" required [(ngModel)]="customerPost.name"
      name="basicName">
  </mat-form-field>
  <mat-form-field appearance="outline" class="create-field-wide">
    <mat-label>Customer Description</mat-label>
    <textarea matInput  required [(ngModel)]="customerPost.description"
    name="basicDescription"></textarea>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Region</mat-label>
    <mat-select matInput  required [(ngModel)]="customerPost.regionId"
      name="region">
      @for (reg of regions | sort:'key'; track reg) {
        <mat-option [value]="reg.value">
          {{ reg.key }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Language</mat-label>
    <mat-select matInput  required [(ngModel)]="customerPost.languageTag"
      name="languageTag">
      @for (lang of customerLanguage | sort:'key'; track lang) {
        <mat-option [value]="lang.value">
          {{ lang.key }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Contact Name</mat-label>
    <input matInput  type="text" required [(ngModel)]="customerPost.contact_Name"
      name="contact_Name">
  </mat-form-field>
  <mat-form-field appearance="outline" class="create-field-wide">
    <mat-label>Contact Address</mat-label>
    <input matInput  type="text"
      [(ngModel)]="customerPost.contact_Address" name="contact_Address">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Contact Telephone</mat-label>
    <input matInput  type="tel"
      [(ngModel)]="customerPost.contact_Telephone" name="contact_Telephone">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Field Support Contact Name</mat-label>
    <input matInput  type="text"
      [(ngModel)]="customerPost.fieldSupportContact_Name" name="fieldSupportContact_Name">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Sales Contact Name</mat-label>
    <input matInput  type="text"
      [(ngModel)]="customerPost.salesContact_Name" name="salesContact_Name">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Customer Type</mat-label>
    <mat-select matInput  required [(ngModel)]="customerPost.customerTypeId"
      name="customerType">
      @for (cat of types; track cat) {
        <mat-option [value]="cat.value">
          {{ cat.key }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

</form>
</div>
<div mat-dialog-actions class="create-actions">
  <button mat-stroked-button type="button" (click)="onNoClick()">Cancel</button>
  <button mat-flat-button type="submit" form="create-customer-form" class="create-primary" [disabled]="!customerForm.form.valid">Create customer</button>
</div>
